import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';
import { UpdateAccountComponent } from './components/update-account/update-account.component';
import { UpdateAddressComponent } from './components/update-address/update-address.component';
import { UpdatePaymentMethodComponent } from './components/update-payment-method/update-payment-method.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { NewPaymentCardComponent } from './components/new-payment-card/new-payment-card.component';
import { DeleteShippingAddressComponent } from './components/delete-shipping-address/delete-shipping-address.component';
import { CreateShippingAddressComponent } from './components/create-shipping-address/create-shipping-address.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      {
        path: 'compte', canActivate: [TokenLocalStorageService], children : [
          { path: 'modifier', pathMatch: 'full', component: UpdateAccountComponent },
          { path: 'adresses/ajouter/adresse-livraison', pathMatch: 'full', component: CreateShippingAddressComponent },
          { path: 'adresses/supprimer/adresse-livraison', pathMatch: 'full', component: DeleteShippingAddressComponent },
          { path: 'adresses/modifier/:type', pathMatch: 'full', component: UpdateAddressComponent },
          { path: 'paiement/modifier/iban', pathMatch: 'full', component: UpdatePaymentMethodComponent },
          { path: 'paiement/enregistrer/cb', pathMatch: 'full', component: NewPaymentCardComponent },
          { path: 'mot-de-passe/modifier', pathMatch: 'full', component: UpdatePasswordComponent },
          { path: ':tab', component: AccountDetailsComponent },
          { path: '', component: AccountDetailsComponent }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
